const sectionCardStepInstructionsCss = `
[data-type='section-card-step-instructions'] .swiper-pagination {
  margin-top: 20px;
  position: relative;
}

[data-type='section-card-step-instructions'] .swiper-pagination .swiper-pagination-bullet {
  opacity: 1;
  background-color: var(--pagination-inactive-color, #cccccc);
}

[data-type='section-card-step-instructions'] .swiper-pagination .swiper-pagination-bullet-active {
  background-color: var(--pagination-active-color, #000) !important;
}

[data-type='section-card-step-instructions'] .card-step-instructions {
  padding-block: 40px;
}

[data-type='section-card-step-instructions'] .steps-title h1,
[data-type='section-card-step-instructions'] .steps-title h2,
[data-type='section-card-step-instructions'] .steps-title h3 {
  font-size: 24px;
  line-height: 29px;
  margin: 0 0 24px 0 !important;
}

[data-type='section-card-step-instructions'] .steps-title p {
  font-size: 16px;
  margin-bottom: 16px !important;
}

[data-type='section-card-step-instructions'] .card-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

[data-type='section-card-step-instructions'] .card-item .step-image {
  order: 1;
  border-radius: 16px;
  position: relative;
  overflow: hidden;
  width: 100%;
  aspect-ratio: 1 / 1;
}

[data-type='section-card-step-instructions'] .card-item .step-image img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
  border-radius: 16px;
}

[data-type='section-card-step-instructions'] .card-item .step-number {
  order: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: solid 3px #000;
  font-size: 24px;
  font-weight: bold !important;
  color: #000;
}

[data-type='section-card-step-instructions'] .card-item .step-content {
  order: 3;
  font-size: 16px;
  line-height: 1.5;
  text-align: center;
}

@container (min-width: 768px) {
  [data-type='section-card-step-instructions'] .card-item:not(:nth-child(3n)):not(:last-child)::after {
    content: '';
    position: absolute;
    right: -43px;
    top: 35%;
    width: 48px;
    height: 48px;
    background-color: var(--arrow-color, currentColor);
    mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23000' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m9 18 6-6-6-6'/%3E%3C/svg%3E");
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: contain;
    -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23000' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m9 18 6-6-6-6'/%3E%3C/svg%3E");
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    -webkit-mask-size: contain;
  }
}

@container (max-width: 768px) {
  [data-type='section-card-step-instructions'] .card-step-instructions {
    padding-block: 16px;
  }

  [data-type='section-card-step-instructions'] .steps-title h1,
  [data-type='section-card-step-instructions'] .steps-title h2,
  [data-type='section-card-step-instructions'] .steps-title h3 {
    font-size: 20px;
    line-height: 24px;
  }

  [data-type='section-card-step-instructions'] .steps-title p {
    font-size: 14px;
  }

  [data-type='section-card-step-instructions'] .card-item .step-image {
    order: 2;
  }

  [data-type='section-card-step-instructions'] .card-item .step-number {
    order: 1;
  }
}
`;
export default sectionCardStepInstructionsCss;
